import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AddressFlow from '../../../user-flow/individual/revampedUserFlow/address/AddressFlow';
import { AppDispatch, UserFlowReducer } from '../../../../store.type';
import {
  getUserFlowReducer,
  selectNewBeneState,
  selectTransactionDetails,
  selectUserSessionReducer,
  selectUserStatusReducer
} from '@Redux/selectors';
import { BeneficiaryFlowState } from '../../types';
import { handleBeneSubmit } from '../bank-details/utils/methods';
import { RecipientAddressProps } from './utils/types';
import { BENE_FORM } from '../../constants/commons';
import { scrollToTop } from '@Redux/actions/ui-trigger';

const RecipientAddress: React.FC<RecipientAddressProps> = (props) => {
  const { is_partially_editable, is_completely_editable } = window.history.state?.usr || {};

  const dispatch = useDispatch<AppDispatch>();
  const parentState = props?.parentState || {};
  const { isRedirectedFromSendMoney, beneState: bankDetails, isEditFlow } = parentState;

  const {
    formValues: currentFormValues,
    isBeneSchemaEnabled,
    payoutApiResponse,
    currentBene,
    addressConfig = {},
    currentBeneId: beneId
  } = useSelector(selectNewBeneState) as BeneficiaryFlowState;

  const userStatusReducer = useSelector(selectUserStatusReducer);
  const transactionDetails = useSelector(selectTransactionDetails);
  const { user_session } = useSelector(selectUserSessionReducer);
  const { timeline, screens } = useSelector(getUserFlowReducer) as UserFlowReducer;

  const onSubmit = async (values: any) => {
    const valuesToSubmit = {};
    if (!isBeneSchemaEnabled) {
      Object.keys(addressConfig).forEach((key) => {
        if (values[key] !== undefined) {
          //@ts-ignore
          valuesToSubmit[key as string] = values[key];
        }
      });
    }

    const updatedFormValues = {
      ...currentFormValues,
      ...(!isBeneSchemaEnabled ? valuesToSubmit : values)
    };
    const config_id = currentBene?.beneficiary_routing_config_id;

    // AUSTRAC: in the edit flow, when the remitter or the beneficiary's bank account is
    // AU-based, the beneficiary's country of residence must match their bank account country.
    const beneCountryCode = isEditFlow
      ? currentBene?.country_code || currentBene?.beneficiary_country_code
      : undefined;
    const bankAccCountryToUse = isEditFlow
      ? currentBene?.bank_account_country || currentBene?.destination_country
      : undefined;
    const isAustracCase =
      isEditFlow && [userStatusReducer?.country_code, bankAccCountryToUse].includes('AU');
    const mismatchedCountry = isAustracCase && beneCountryCode !== bankAccCountryToUse;
    const shouldUpdateCountry = isAustracCase && mismatchedCountry;

    const additionalData = {
      user_session,
      userStatusReducer,
      transactionDetails,
      screens,
      timeline,
      config_id,
      is_partially_editable,
      is_completely_editable,
      beneId,
      bankDetails,
      isEditFlow,
      currentFormBeneAddress: !isBeneSchemaEnabled ? valuesToSubmit : values,
      bankAccCountryToUse,
      shouldUpdateCountry
    };
    await handleBeneSubmit(
      updatedFormValues,
      isBeneSchemaEnabled,
      '',
      dispatch,
      BENE_FORM,
      additionalData,
      isRedirectedFromSendMoney,
      true,
      payoutApiResponse
    );

    dispatch(scrollToTop());
  };

  return <AddressFlow isEditFlow={isEditFlow} isBeneAddressFlow onSubmitBeneFlow={onSubmit} />;
};

export default RecipientAddress;
